var map = {
	"./add.svg": 22586,
	"./banco-do-brasil.svg": 40505,
	"./bradesco.svg": 95488,
	"./caixa.svg": 45670,
	"./inter.svg": 77290,
	"./itau.svg": 81513,
	"./nubank.svg": 87665,
	"./remove.svg": 41096,
	"./santander.svg": 67941,
	"./sync.svg": 34633
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46752;